import { useState, useEffect } from 'react';
import {
  DgtPdOrderPicklistExtraReturn
} from '../models'

import { getReturnPicklist } from  '../states/PicklistAction'

export default function usePicklistReturnDetail(
  id: string) : [ DgtPdOrderPicklistExtraReturn | undefined, (updated: DgtPdOrderPicklistExtraReturn) => void] {
  const [ returnPicklist, setReturnPicklist ] = useState<DgtPdOrderPicklistExtraReturn>();

  const mutatePicklist = (updatedPicklist: DgtPdOrderPicklistExtraReturn) => {
    setReturnPicklist(updatedPicklist)
  }

  useEffect(() => {
    const fetchReturn = async (id: string) => {
      const returnPicklist = await getReturnPicklist(id)
      setReturnPicklist(returnPicklist)
    }

    fetchReturn(id)
  }, [ id ]);

  return [ returnPicklist, mutatePicklist ];
}